import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Condition } from "@/modules/FormTemplate/models/Condition";
import ConditionalFieldComponent from "./ConditionalFieldComponent/ConditionalFieldComponent.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";

Vue.use(Vuetify);

@Component({
  name: "CoditionalComponent",
  components: {
    EmptyState,
    ConditionalFieldComponent,
    ModalTemplate
  }
})
export default class ConditionalComponent extends Vue {
  @Prop() private conditions!: Condition[];
  @Prop() private condition!: Condition;
  @Prop() private index!: number;

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  CONDITION_EMPTY_STATE_HEADER =
    FORM_TEMP_CONSTANTS.CONDITION_LABEL.EMPTY_STATE_TITLE;
  CONDITION_EMPTY_STATE_PARAGRAPH =
    FORM_TEMP_CONSTANTS.CONDITION_LABEL.EMPTY_STATE_PARAGRAPH;

  EDIT_CONDITION =
    FORM_TEMP_CONSTANTS.CONDITIONAL_COMPONENT_TOOLTIPS.BTN_TOOLTIPS
      .EDIT_CONDITION;
  DELETE_CONDITION =
    FORM_TEMP_CONSTANTS.CONDITIONAL_COMPONENT_TOOLTIPS.BTN_TOOLTIPS
      .DELETE_CONDITION;
  ADD_FIELD =
    FORM_TEMP_CONSTANTS.CONDITIONAL_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.ADD_FIELD;

  editCondition() {
    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.EDIT,
      this.index
    );
  }

  deleteCondition() {
    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.DELETE,
      this.index
    );
  }
  addFielConditional() {
    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.FIELD.ADD_NEW_FIELD_CONDITIONAL_FORM,
      this.index
    );
  }

  modifyConditionalField(action: string, data: any) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY, action, data);
  }
}
